import React from "react";
import { bulan, tahun } from "../../util/constant";
import "./TableQualityControl.css";

const TableQualityControl = ({
  dataQc,
  shiftQc,
  setShiftQc,
  dateQc,
  setDateQc,
  dataTopPlate,
  exportBerat,
  bulanExport,
  setBulanExport,
  tahunExport,
  setTahunExport,
}) => {
  return (
    <div className="tqc_root">
      {/* ===== Filter ===== */}
      <div className="tqc_filters">
        <div className="tqc_field">
          <label className="tqc_label" htmlFor="tqc_shift">
            Pilih Shift
          </label>
          <select
            id="tqc_shift"
            className="tqc_input"
            value={shiftQc}
            onChange={(e) => setShiftQc(e.target.value)}
          >
            <option disabled>Pilih Shift</option>
            <option value="1">Shift 1</option>
            <option value="2">Shift 2</option>
            <option value="3">Shift 3</option>
          </select>
        </div>

        <div className="tqc_field">
          <label className="tqc_label" htmlFor="tqc_date">
            Pilih Tanggal
          </label>
          <input
            id="tqc_date"
            type="date"
            className="tqc_input"
            value={dateQc}
            onChange={(e) => setDateQc(e.target.value)}
          />
        </div>

        <div className="tqc_field">
          <label className="tqc_label" htmlFor="tqc_bulan">
            Bulan
          </label>
          <select
            id="tqc_bulan"
            className="tqc_input"
            value={bulanExport}
            onChange={(e) => setBulanExport(Number(e.target.value))}
          >
            <option disabled>Bulan</option>
            {bulan.map((ele) => (
              <option key={ele.value} value={ele.value}>
                {ele.name}
              </option>
            ))}
          </select>
        </div>

        <div className="tqc_field">
          <label className="tqc_label" htmlFor="tqc_tahun">
            Pilih Tahun
          </label>
          <select
            id="tqc_tahun"
            className="tqc_input"
            value={tahunExport}
            onChange={(e) => setTahunExport(e.target.value)}
          >
            <option disabled>Pilih Bulan</option>
            {tahun.map((data) => (
              <option key={data} value={data}>
                {data}
              </option>
            ))}
          </select>
        </div>

        <button
          type="button"
          className="tqc_button"
          onClick={() => exportBerat()}
        >
          Export Berat
        </button>
      </div>

      {/* ===== Tabel utama ===== */}
      <div className="tqc_card">
        <div className="tqc_scroll">
          <table className="tqc_table">
            <thead>
              <tr>
                <th className="tqc_col_mesin">Mesin</th>
                <th className="tqc_col_cust">Customer</th>
                <th>Mold</th>
                <th>Bahan</th>
                <th className="tqc_hide_mobile">Color</th>
                <th className="tqc_col_num">Runner</th>
                <th className="tqc_col_num">Berat (gr)</th>
              </tr>
            </thead>
            <tbody>
              {dataQc && dataQc.length > 0 ? (
                dataQc.map((data, index) => (
                  <tr key={index}>
                    <td className="tqc_cell_mesin">{data.mesin}</td>
                    <td>{data.customer}</td>
                    <td>{data.moldType}</td>
                    <td>{data.material}</td>
                    <td className="tqc_hide_mobile">{data.color}</td>
                    <td className="tqc_cell_num">
                      {data.runnerQc ? data.runnerQc : "0"} gr
                    </td>
                    <td className="tqc_cell_num">
                      {data.beratQc ? data.beratQc : "0"} gr
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="tqc_empty" colSpan={7}>
                    Belum ada data untuk shift dan tanggal ini.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ===== Top Plate ===== */}
      {dataTopPlate ? (
        <>
          <p className="tqc_section_title">Data Top Plate</p>
          <div className="tqc_card">
            <div className="tqc_scroll">
              <table className="tqc_table">
                <thead>
                  <tr>
                    <th className="tqc_col_mesin">Mesin</th>
                    <th className="tqc_col_cust">Customer</th>
                    <th>Mold</th>
                    <th>Bahan</th>
                    <th className="tqc_col_num">Berat (gr)</th>
                  </tr>
                </thead>
                <tbody>
                  {dataTopPlate.length > 0 ? (
                    dataTopPlate.map((data, index) => (
                      <tr key={index}>
                        <td className="tqc_cell_mesin">{data.mesin}</td>
                        <td>{data.customer}</td>
                        <td>{data.moldType}</td>
                        <td>{data.material}</td>
                        <td className="tqc_cell_num">
                          {data.berat ? data.berat : "0"} gr
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="tqc_empty" colSpan={5}>
                        Belum ada data top plate.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};
export default TableQualityControl;
